<div class="agenx-paginator" [hidden]="pages.length < 2">
  <ul class="agenx-paginator__dots" >
    <li [ngClass]="{'agenx-paginator__arrow--disabled': currentPage === 1}" (click)="clickOnArrow('left')"
      class="agenx-paginator__arrow">
      <img class="agenx-paginator__arrow-img agenx-paginator__arrow-img--left"
        [src]="icon_arrow_src" alt="Alert Icon">
    </li>
    @for (page of pages; track page) {
    <li (click)="changePage(page)" class="agenx-paginator__dot"
      [ngClass]="{'agenx-paginator__dot--active': page === currentPage}">
    </li>
    } @empty {
    <li class="agenx-paginator__dot"></li>
    }
    <li [ngClass]="{'agenx-paginator__arrow--disabled': currentPage === pages.length}" (click)="clickOnArrow('right')"
      class="agenx-paginator__arrow">
      <img class="agenx-paginator__arrow-img" [src]="icon_arrow_src" alt="Alert Icon">
    </li>
  </ul>
</div>
